import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const NasfModalidades = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="NASF-AB" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Coordenador do NASF-AB" nome="coordenadornafs" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="63vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Modalidade de NASF-AB" nome="modalidadenafs" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["1", "2", "3"]} />
                        <Input label="Secretário de Saúde do Município" nome="secretarionafs" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="78vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Endereço da Secretaria de Saúde do Município" nome="secretarianafs" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="78vw" widthMobile="80vw" marginR="3vw" />
                    </div>
                </Caixa >
            )
        }
        return partes
    }
}

export default NasfModalidades